import React, { memo } from 'react'
import cn, { Argument as ClassName } from 'classnames'

import Text from '../../../../ui/Text'
import { WidgetLayout } from '../../../../lib/widget-layout'
import { TableBodyCell, TableRow, Table, TableBody } from '../../../../lib/table'
import { MeasurementDeviceExtendedGetModel } from '../../../redux/api/web-api'
import useText from '../../../hooks/useText'

export type MeasurementDeviceDetailsWidgetProps = {
    device?: MeasurementDeviceExtendedGetModel
    className?: ClassName
    style?: React.CSSProperties
}

export const MeasurementDeviceDetailsWidget = memo(function MeasurementDeviceDetailsWidget({
    device,
    className,
    style,
}: MeasurementDeviceDetailsWidgetProps): React.ReactElement {
    const text = useText()
    const statusText = (status: boolean) => (status ? text('lblTrueStatus') : text('lblFalseStatus'))

    return (
        <WidgetLayout
            className={cn(className)}
            style={style}
            title={text('lblMeasurementDevicePage', { name: device?.serialNumber })}
            data-testid="details-widget"
        >
            <Table>
                <TableBody>
                    <TableRow>
                        <TableBodyCell data-testid="table-TableRow-name">
                            <Text code="lblName" />:
                        </TableBodyCell>
                        <TableBodyCell data-testid="table-td-name">
                            {device?.name || device?.serialNumber}
                        </TableBodyCell>
                    </TableRow>
                    <TableRow>
                        <TableBodyCell data-testid="table-TableRow-desc">
                            <Text code="lblDescription" />:
                        </TableBodyCell>
                        <TableBodyCell data-testid="table-td-desc">{device?.description || '---'}</TableBodyCell>
                    </TableRow>
                    <TableRow>
                        <TableBodyCell data-testid="table-TableRow-installation">
                            <Text code="lblPointOfInstallation" />:
                        </TableBodyCell>
                        <TableBodyCell data-testid="table-td-installation">
                            {device?.pointOfInstallation || '---'}
                        </TableBodyCell>
                    </TableRow>
                    <TableRow>
                        <TableBodyCell data-testid="table-TableRow-detailed-desc">
                            <Text code="lblDetailedDescription" />:
                        </TableBodyCell>
                        <TableBodyCell data-testid="table-td-detailed-desc">
                            {device?.detailedDescription || '---'}
                        </TableBodyCell>
                    </TableRow>
                    <TableRow>
                        <TableBodyCell data-testid="table-TableRow-power">
                            <Text code="lblSystemWithPowerGenerators" />:
                        </TableBodyCell>
                        <TableBodyCell data-testid="table-td-power">
                            {statusText(!device?.ignoreCurrentDirection)}
                        </TableBodyCell>
                    </TableRow>
                    <TableRow>
                        <TableBodyCell data-testid="table-TableRow-active">
                            <Text code="lblActive" />:
                        </TableBodyCell>
                        <TableBodyCell data-testid="table-td-active">{statusText(!!device?.active)}</TableBodyCell>
                    </TableRow>
                </TableBody>
            </Table>
        </WidgetLayout>
    )
})
